namespace aq.ui {

    export class AqSidebarNavController {
        public data: common.models.SidebarNavItem[];
        private sidenavId: string = 'aq-sidenav';
        /* @ngInject */
        constructor(
            private $mdMedia: angular.material.IMedia,
            private $mdSidenav: angular.material.ISidenavService,
            private Auth: aq.services.Auth
        ) { }

        public toggle() {
            const sidenav = this.$mdSidenav(this.sidenavId);
            this.isOpen() && !this.isLargeScreen() ? sidenav.close() : sidenav.open();
        };
        public isOpen() {
            return this.$mdSidenav(this.sidenavId).isOpen() || this.isLargeScreen();
        };
        public isLargeScreen() {
            return this.$mdMedia('gt-sm');
        }
        public isMediumScreen() {
            return this.$mdMedia('gt-xs');
        }
        public close() {
            const sidenav = this.$mdSidenav(this.sidenavId);
            sidenav.close();
        }
    }

    angular
        .module('aq.ui')
        .component('aqSidebarNav', {
            controller: AqSidebarNavController,
            controllerAs: 'vm',
            templateUrl: 'app/common/directives/aqSidebarNav/aqSidebarNav.html',
            bindings: {
                data: '<'
            },
            transclude: true
        });
}
